import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/header.css";

const Header: React.FC = () => {
  return (
    <header className="site-header">
      <div className="header-inner thin-header">
        <p className="company-name">Truhlářství Smolek</p>
        <nav className="main-nav" aria-label="Hlavní navigace">
          <NavLink
            to="/o-firme"
            className={({ isActive }) => (isActive ? "nav-link nav-link-active" : "nav-link")}
          >
            O firmě
          </NavLink>
          <NavLink
            to="/vyrobky"
            className={({ isActive }) => (isActive ? "nav-link nav-link-active" : "nav-link")}
          >
            Výrobky
          </NavLink>
          <NavLink
            to="/kontakt"
            className={({ isActive }) => (isActive ? "nav-link nav-link-active" : "nav-link")}
          >
            Kontakt
          </NavLink>
        </nav>
        <div className="header-actions" aria-label="Kontakty">
          <a className="icon-link" href="tel:+420774868657" aria-label="Zavolat">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M6.6 10.8a15.2 15.2 0 0 0 6.6 6.6l2.2-2.2a1.1 1.1 0 0 1 1.1-.3c1 .3 2 .4 3 .4.6 0 1 .5 1 1V20a1 1 0 0 1-1 1C10.6 21 3 13.4 3 4a1 1 0 0 1 1-1h3.4c.5 0 1 .4 1 1 0 1 .1 2 .4 3 .1.4 0 .8-.3 1.1z" />
            </svg>
          </a>
          <a className="icon-link" href="mailto:info@truhlarstvismolek.cz" aria-label="Poslat e-mail">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M3 6.5A2.5 2.5 0 0 1 5.5 4h13A2.5 2.5 0 0 1 21 6.5v11a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 17.5zm2 .5V8l7 4.8L19 8V7z" />
            </svg>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
